var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"date",class:{new: _vm.entryData.newIcon}},[(_vm.entryData.categoryName)?_c('span',{staticClass:"category",style:({backgroundColor: _vm.entryData.categoryLabelColor, color: _vm.entryData.categoryColor})},[_vm._v(_vm._s(_vm.entryData.categoryName))]):_vm._e(),_vm._v(_vm._s(_vm.entryData.date))])
}
var staticRenderFns = []

export { render, staticRenderFns }